import { userProfileService } from '@/services/user-profile.service';
import axios from 'axios';

const initialState = () => ({
  userProfile: null,
  status: {
    error: null,
    pending: true,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  getUserProfile({ commit }) {
    commit('GET_USER_PROFILE');
    return userProfileService.getUserProfile().then(
      (response) => commit('SUCCESS', response),
      (error) => {
        if (!axios.isCancel(error)) {
          commit('ERROR', error);
        }
      },
    );
  },
  saveUserProfile({ commit }, userProfile) {
    commit('REFRESH');
    return userProfileService.saveUserProfile(userProfile).then(
      (response) => commit('SUCCESS', response),
      (error) => {
        if (!axios.isCancel(error)) {
          commit('ERROR', error);
        }
      },
    );
  },
  patchUserProfile({ commit }, userProfile) {
    commit('REFRESH');
    return userProfileService.patchUserProfile(userProfile).then(
      (response) => commit('SUCCESS', response),
      (error) => {
        if (!axios.isCancel(error)) {
          commit('ERROR', error);
        }
      },
    );
  },
};

const mutations = {
  GET_USER_PROFILE(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
    state.userProfile = null;
  },
  REFRESH(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  SUCCESS(state, userProfile) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.userProfile = userProfile;
  },
  ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error: error,
    };
  },
  RESET(state) {
    const initial = initialState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
};

const getters = {
  userProfile: (state) => state.userProfile,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const userProfile = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
